import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as ConnectorBlock } from '../../../images/connector-block.svg';

export const ConnectorBlockIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} component={ConnectorBlock} />
);

export default ConnectorBlockIcon;
